import React from "react";

function Privacy(props) {
  return (
    <div className="bg-gray-100 py-8 px-4 lg:px-0 md:mb-6 animate__animated animate__fadeIn">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-semibold text-gray-800 mb-4">
          Политика конфиденциальности AJAR MEBEL
        </h2>
        <h2 className="text-xl font-semibold text-gray-800 ">
          Ваша конфиденциальность <br />
          Мы ценим вашу конфиденциальность и защищаем личные данные.
        </h2>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Какие данные собираем:
          </h2>
          <ul className="list-decimal pl-6">

          <li className="text-gray-700 mb-4">
            Имя, телефон, e-mail, адрес доставки, платежные данные.
          </li>
          </ul>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Как используем:
          </h2>
        <ul className="list-decimal pl-6">
          <li className="text-gray-700">
            Для обработки заказов, уведомлений о статусе, поддержки клиентов.{" "}
          </li>
          <li>Для отправки акций и предложений (с вашего согласия).</li>
          <li className="text-gray-700">
            При вопросах о нашей политике свяжитесь с нами.
          </li>
        </ul>
          <h2 className="text-3xl font-semibold text-gray-800 mt-12">
            AJAR MEBEL купуялуулук саясаты
          </h2>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Сиздин купуялуулугуңуз <br />
            Сиздин жеке маалыматыңызды коргоого көңүл бурабыз.
          </h2>

          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Чогултулган маалыматтар:
          </h2>
          <ul className="list-decimal pl-6">

          <li className="text-gray-700 mb-4">
            Аты-жөнү, телефону, e-mail, жеткирүү дареги, төлөм маалыматтары.
          </li>
          </ul>
          <h2 className="text-xl font-semibold text-gray-800 mb-4">
            Колдонуу максаты:
          </h2>
          <ul className="list-decimal pl-6">
          <li className="text-gray-700">
            Заказдарды иштетүү, статусту билдирүү, кардарларды колдоо.
          </li>
          <li className="text-gray-700 ">
              Акциялар тууралуу маалымат жөнөтүү (сиздин макулдугуңуз менен).
            </li>
          <li className="text-gray-700">
            Суроолор болсо, биз менен байланышсаңыз болот.
          </li>
          </ul>
            
      </div>
    </div>
  );
}

export default Privacy;
